import {  WEB_SOCKET_RECEIVED } from "../constants/webSocketConstants";

export const webSocketReducer = (
	state = {
		message: null
	},
	action
) => {
   
	switch (action.type) {
		case WEB_SOCKET_RECEIVED:
			return {
				...state,
                message: action.payload
			};

		default:
			return state;
	}
};
